<template>
    <div class="datePicker">
        <DatePicker :confirm="isConfirm" :type="type" :value="value" :options="options" :placeholder="placeholder" @on-open-change="handleOpenChange" @on-change="handleChange"></DatePicker>
        <div :class="`search-datePicker-icon ${open ? 'search-datePicker-icon-open' : ''}`">
            <img src="../image/search/open.png" alt="">
        </div>
    </div>
</template>

<script>
import DatePicker from 'iview/src/components/date-picker';
import moment from 'moment'
export default {
    components: {
        DatePicker
    },
    data() {
        return {
            open: false
        }
    },
    props: {
        placeholder: {
            type: String,
            default: ""
        },
        value: {
            type: Date | String,
            default: ""
        },
        minDate: {
            type: Date | String,
            default: ""
        },
        maxDate: {
            type: Date | String,
            default: ""
        },
        type: {
            type: String,
            default: 'date'
        },
        isConfirm: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        options() {
            const that = this
            return {
                disabledDate(date) {
                    return (that.minDate && new Date(date).getTime() < new Date(that.minDate).getTime() - 86400000) || (that.maxDate && new Date(date).getTime() > new Date(that.maxDate).getTime())
                }
            }
        }
    },
    methods: {
        // 处理时间选择器弹出关闭日历时触发
        handleOpenChange(open) {
            this.open = open
        },

        // 处理选择时间事件
        handleChange(event) {
            this.$emit('change', event)
        }
    }
}
</script>

<style lang="scss" scoped>
.datePicker {
    position: relative;
    /deep/ .ivu-icon-ios-calendar-outline {
        display: none;
    }

    /deep/ .ivu-input {
        height: 30px;
    }
    .search-datePicker-icon {
        position: absolute;
        right: 14px;
        width: 7px;
        height: 4px;
        top: 0;
        bottom: 0;
        margin: auto 0;
        pointer-events: none;
        transition: transform 0.15s;
        > img {
            position: absolute;
            left: 0;
            top: 0;
            width: 7px;
            height: 4px;
        }
    }
    .search-datePicker-icon-open {
        transform: rotate(180deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/datePicker/datePicker.vue